// extracted by mini-css-extract-plugin
module.exports = {"Main":"Footer_Main__18kI1","Footer":"Footer_Footer__2nGIk","Icons":"Footer_Icons__1DkDe"};